import { DtoBase } from "../Utils/DtoBase";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { Key, DeviceKey, IfKey } from "../Core/Keys";
import { IfEntry } from "../InfoSets/IfTable";
import { Device } from "../../DiscoveryEngine.TS/Core/Device";

//import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";

export class UserLinkMember extends DtoBase implements ObjectSerializer {
    public DeviceKey: DeviceKey;
    public IfKey: IfKey;
    public Description: string;

    constructor(device?: Device, ifEntry?: IfEntry) {

        super();

        this.Description = "";
        this.DeviceKey = undefined;
        this.IfKey = undefined;

        if (device && ifEntry) { // If both a Device and IfEntry are passed in
            this.DeviceKey = device.CreateKey();
            this.IfKey = IfKey.Create(device, ifEntry);
            this.Description = device.DisplayName + "(" + ifEntry.DisplayName + ")";
        }
        else if (device) { // If only a Device is passed in
            this.DeviceKey = device.CreateKey();
            this.Description = device.DisplayName;
        }
    }


    get HasDeviceKey():boolean {
        return (this.DeviceKey != null);
    }

    get HasIfKey(): boolean {
        return (this.IfKey != null);
    }

    get HasDescription(): boolean {
        return (this.Description != null || this.Description == "");
    }

    get IfIndex(): string {
        var retval: string = "";
        if (this.HasIfKey) {
            retval = this.IfKey.IfIndex.toString();
        }
        return retval;
    }



    public Clear(): void {
        this.DeviceKey = null;
        this.IfKey = null;
        this.Description = "";
    }

    public Write(obj: any, context: any): void {
        obj.user_link_member = {};
        obj = obj.user_link_member;

        super.Write(obj, context);

        if (this.HasDeviceKey) {
            this.DeviceKey.Write(obj, context);
        }

        if (this.HasIfKey) {
            this.IfKey.Write(obj, context);
        }

        if (this.HasDescription) {
            obj.description = this.Description;
        }

    }

    public Read(obj: any, context: any): void {

        this.Clear();

        if (!obj.user_link_member) {
            throw new Error();
        }
        obj = obj.user_link_member;

        super.Read(obj, context);
        if (obj.device_key !== undefined) {
            this.DeviceKey = new DeviceKey();
            this.DeviceKey.Read(obj, context);
        }
        if (obj.if_key !== undefined) {

            this.IfKey = new IfKey();
            this.IfKey.Read(obj, context);
        }
        if (obj.description !== undefined) {
            this.Description = obj.description;
        }
    }

}